import BaseListagem, { BaseListagemRef } from "components/BaseListagem";
import ModalDocumentoVisualizar from "components/modal/documentos/ModalDocumentoVisualizar";
import Usuario from "model/administracao/cadastro/Usuario";
import CategoriaDocumento from "model/documentos/CategoriaDocumento";
import DocumentoVersao from "model/documentos/DocumentoVersao";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import DocumentoService from "service/documentos/DocumentoService";
import DocumentoVersaoService from "service/documentos/DocumentoVersaoService";
import { converterData } from "utils/convert";
import { IdMatchModeOptions, TextMatchModeOptions, dateRangeFilterTemplate, dropdownFilterTemplate, filterApplyTemplate, statusFilterTemplate } from "utils/filterUtils";

const documentoVersaoService = new DocumentoVersaoService();
const documentoService = new DocumentoService();
export default function DocumentosPendenciasListagem() {

    const [queryParameters] = useSearchParams();

    const [titulo, setTitulo] = useState<string>('Documentos');

    const [categorias, setCategorias] = useState<CategoriaDocumento[]>([]);
    const [documentoVisualizar, setDocumentoVisualizar] = useState<{ visible: boolean, documentoVersao: DocumentoVersao | null, url: string }>({ visible: false, documentoVersao: null, url: "" });
    const listagemRef = useRef<BaseListagemRef>(null);

    useEffect(() => {
        documentoService.categorias().then((response) => {
            setCategorias(response);
        }).catch((error) => {
            console.error("Erro ao buscar categorias:", error);
        });
    }, [])

    const defaultFilters: DataTableFilterMeta = {
        codigoInterno: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        nome: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        categoria: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
        status: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
        prazo: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
    }

    return (
        <>
            {documentoVisualizar.visible ? <ModalDocumentoVisualizar
                url={documentoVisualizar.url}
                visible={documentoVisualizar.visible}
                onHide={() => {
                    listagemRef.current?.reload();
                    setDocumentoVisualizar({ visible: false, documentoVersao: null, url: "" })
                }}
                documentoVersao={documentoVisualizar.documentoVersao}
            /> : null}

            <BaseListagem
                ref={listagemRef}
                ordenacao="documento.nome,ASC"
                service={documentoVersaoService}
                urlService="/documentoVersao"
                showRemoveButton={false}
                showNewButton={false}
                showEditButton={true}
                tituloPagina={titulo}
                defaultFilters={defaultFilters}
                showClearFilterButton
                nome="documentoPendenciasListagem"
            >
                <Column field="documento.codigoInterno" header="Código" filter filterField="codigoInterno" showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />

                <Column field="documento.nome" header="Titulo" filter filterField="nome" showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />

                <Column field="documento.categoria.nome" header="Categoria" filter filterField="categoria" showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => dropdownFilterTemplate(options, categorias)} />
                <Column field="status" header="Status" body={(rowData) => {
                    return <span style={{ borderRadius: 20, padding: 5, paddingLeft: 10, paddingRight: 10, background: documentoService.getStatusColor(rowData.status) }}>{documentoVersaoService.getStatus(rowData.status)}</span>
                }} filter filterField="status" showFilterOperator={false} showAddButton={false}
                    showFilterMatchModes={false} filterApply={filterApplyTemplate} filterElement={(options) => statusFilterTemplate(options, documentoVersaoService.statusesFilter())} />
                <Column field="prazo" header="Prazo" body={(rowData: DocumentoVersao) => { return rowData.status == "EM_REVISAO" ? converterData(rowData.prazoRevisao) : rowData.status == "AGUARDANDO_APROVACAO" ? converterData(rowData.prazoAprovacao) : converterData(rowData.prazo) }}
                    filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro" filterField="prazo"
                    filterElement={dateRangeFilterTemplate} showFilterMenuOptions={false} filterApply={filterApplyTemplate} filterMenuStyle={{ zIndex: 50 }} />
                <Column field="sequencial" header="Versão" filter filterField="sequencial" showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                    filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
                <Column body={(rowData) => {
                    if (rowData.arquivo == null) {
                        return <></>
                    }
                    return <Button icon="pi pi-eye"
                        onClick={() => setDocumentoVisualizar({ visible: true, documentoVersao: rowData, url: rowData?.arquivo?.url || "" })}
                    />
                }} />
            </BaseListagem>
        </>
    )
}